export enum UserRole {
  Administrator = 'manager',
  GeneralUser = 'user',
}

export enum UserRoleLabel {
  Administrator = '管理者',
  GeneralUser = '一般ユーザー',
}

export const userRoleOptions = [
  { value: UserRole.Administrator, label: UserRoleLabel.Administrator },
  { value: UserRole.GeneralUser, label: UserRoleLabel.GeneralUser },
];
